/*
 * @Author: codesides
 * @Descripttion:
 * @Date: 2022-05-11 13:26:20
 * @LastEditors: codesides
 * @LastEditTime: 2025-10-31 13:55:28
 * @FilePath: \lesson-web-cms\src\axios\index.ts
 */
/**
 * axios封装
 * 请求拦截、响应拦截
 */
import axios, {AxiosResponse} from "axios";
import Cookies from "js-cookie";
import {message} from "ant-design-vue";
import {logout} from "@/utils/tools";
import router from "@/router/index";
import {HOME_PREFIX} from "@/utils/config";

export interface HttpRes<T> {
    code: number | string;
    data: T;
    msg?: string;
    status: boolean;
}

// 创建axios实例
const instance = axios.create({
    baseURL: "",
    timeout: 1000 * 300, // 请求超时
});

// 请求拦截器
instance.interceptors.request.use((config) => {

    const XAccessToken = Cookies.get("X-Access-Token")
    if (XAccessToken) {
        config.headers["X-Access-Token"] = XAccessToken
    }

    const Authorization = Cookies.get("Authorization");
    if (Authorization) {
      config.headers["Authorization"] = Authorization;
    }

    config.headers = config.headers || {};
    // const accessToken = Cookies.get("accessToken");
    if (HOME_PREFIX.length > 0 && config.url.startsWith(HOME_PREFIX) ) {
        config.url = `${config.url.replace(HOME_PREFIX, `${HOME_PREFIX}/api`)}`
    } else {
        config.baseURL = /^\/page/.test(config.url as string) ? "" : "/api";
    }
    // if (accessToken) {
    //     config.headers.Authorization = accessToken || "";
    // }
    return config;
});

// 响应拦截器
instance.interceptors.response.use(
    // http请求成功
    (response: AxiosResponse<HttpRes<object>>) => {
        let {code, msg} = response.data;
        // 响应如果是blob二进制流数据，如果内容大于0，直接给2000状态码进入正常逻辑
        if (response.request.responseType === "blob") {
            const fielName =
                response.headers["meal-file-export"] ||
                response.headers["Meal-File-Export"];
            const exportMsg =
                response.headers["meal-verify-msg"] ||
                response.headers["Meal-Verify-Msg"];
            if (!fielName) {
                const dsp = response.headers["content-disposition"];
                const ct = response.headers["content-type"];
                const tIdx = dsp.indexOf("filename=");
                const tTyp = ct.indexOf("application/json;");

                if (tIdx === -1) {
                    code = 4000;
                    msg = decodeURI(exportMsg);
                } else if (tTyp !== -1) {
                    code = 9999;
                } else {
                    code = 2000;
                    msg = "导出成功";
                    (
                        (<object>response.data) as {
                            fielName: string;
                        }
                    ).fielName = dsp.slice(tIdx + 9);
                }
            } else {
                code = 2000;
                msg = "导出成功";
                (
                    (<object>response.data) as {
                        fielName: string;
                    }
                ).fielName = fielName;
            }
        }

        switch (code) {
            case 2000:
                return response.data;
            case 404:
            case 500:
            case 502:
            case 510:
            case 5000:
                message.error({content: msg, key: "netMsg", duration: 2});
                return Promise.reject(response.data);
            case 4000:
                message.error({content: msg, key: "netMsg", duration: 2});
                return Promise.reject(response.data);
            // 9000 无权限
            case 9000:
                message.error({content: "暂无权限", key: "netMsg", duration: 2});
                return Promise.reject(response.data);
            // 9001 用户未授权或授权过期
            case 9001:
            case 10000:
                console.log(3)
                message.error({
                    content: "用户未授权或授权过期",
                    key: "netMsg",
                    duration: 2,
                });
                router.replace({
                    path: "/noPermission",
                    query: {
                        code: 9000,
                    },
                });
                return Promise.reject(response.data);
            case 9002:
                message
                    .error({
                        content: "用户角色身份错误，请重新登录!",
                        key: "netMsg",
                        duration: 2,
                    })
                    .then(() => {
                        logout();
                    });
                return Promise.reject(response.data);
            case 9999:
                return Promise.reject(response.data);
            default:
                message.error({content: msg, key: "netMsg", duration: 2});
                return Promise.reject(response.data);
        }
    }
);

export default instance;
